import { __read } from 'tslib';
import { useContext, useMemo } from 'react';
import { AvailableCountries } from '@invitae/location-lite-react';
import { CountryLocationContext } from '../localization/context.esm.js';
import { CREATE_PREFIX_REGEX, addCountryCodeToPath, countryCodeIndicatorFromPath } from '../localization/utils.esm.js';

/**
 * Hook that provides functions involving country codes
 * @returns object
 */
var useCountryLocationPrefix = function () {
    var _a = useContext(CountryLocationContext), pathCountryCode = _a.countryCode, enableCountryLocationControls = _a.enableCountryLocationControls;
    var countryCodes = useMemo(function () { return AvailableCountries; }, []);
    var removeUrlPrefix = function (url) {
        return url.replace(CREATE_PREFIX_REGEX(), '/');
    };
    var addCountryCodePrefix = function (path) { return addCountryCodeToPath(pathCountryCode, path); };
    /**
     * Changes the URL prefix if identified
     * Eg: changeUrlPrefix('/au/cancer', 'US') -> '/us/cancer'
     */
    var changeUrlPrefix = function (url, countryCode) {
        var _a = __read(countryCodeIndicatorFromPath(url), 1), countryCodeFromPath = _a[0];
        var prefix = countryCode.toLowerCase();
        var pathWithCountryCode = !countryCodeFromPath ? addCountryCodeToPath('US', url) : url;
        var countryCodeRegExp = new RegExp("/".concat(countryCodeFromPath || 'us'), 'i');
        return pathWithCountryCode.replace(countryCodeRegExp, "/".concat(prefix));
    };
    /**
     * Returns the country code identified from path
     * Eg: getCountryCodeFromPath('/us/cancer') -> 'us'
     */
    var getCountryCodeFromPath = function (path) {
        var _a = __read(countryCodeIndicatorFromPath(path), 1), countryCodeFromPath = _a[0];
        return countryCodeFromPath;
    };
    return {
        addCountryCodePrefix: addCountryCodePrefix,
        changeUrlPrefix: changeUrlPrefix,
        countryCodes: countryCodes,
        enableCountryLocationControls: enableCountryLocationControls,
        getCountryCodeFromPath: getCountryCodeFromPath,
        pathCountryCode: pathCountryCode,
        removeUrlPrefix: removeUrlPrefix,
    };
};

export { useCountryLocationPrefix };
//# sourceMappingURL=useCountryLocationPrefix.esm.js.map
